import React from 'react';

function FacebookDarkIcon() {
  return (
    <svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1">
      <title>icon_facebook</title>
      <defs>
        <polygon
          id="path-1"
          points="6.59090909e-05 0.0138289773 28.9871477 0.0138289773 28.9871477 28.5 6.59090909e-05 28.5"
        ></polygon>
        <polygon
          id="path-3"
          points="0.0588988304 0.148830924 13.6502322 0.148830924 13.6502322 24.5555556 0.0588988304 24.5555556"
        ></polygon>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Academy-Landing-v2.0"
          transform="translate(-234.000000, -7128.000000)"
        >
          <g id="DarkFooter" transform="translate(88.000000, 7021.000000)">
            <g id="icon_facebook" transform="translate(146.000000, 107.000000)">
              <g id="Group-3">
                <g id="Fill-1-Clipped">
                  <g>
                    <mask id="mask-2" fill="white">
                      <use xlinkHref="#path-1"></use>
                    </mask>
                    <g id="path-1"></g>
                    <path
                      d="M28.9872136,22.6486585 C28.9872136,25.8811415 26.3215205,28.5000648 23.0334807,28.5000648 C21.2223593,28.5000648 19.8640184,28.5000648 18.9584577,28.5000648 C16.06868,28.5000648 11.7340134,28.5000648 5.95445795,28.5000648 C2.66592386,28.5000648 6.59090909e-05,25.8811415 6.59090909e-05,22.6486585 L6.59090909e-05,5.86491136 C6.59090909e-05,2.63307614 2.66592386,0.0138289773 5.95445795,0.0138289773 L23.0334807,0.0138289773 C26.3215205,0.0138289773 28.9872136,2.63307614 28.9872136,5.86491136 L28.9872136,22.6486585 Z"
                      id="Fill-1"
                      fill="#000000"
                      fillRule="nonzero"
                      mask="url(#mask-2)"
                    ></path>
                  </g>
                </g>
              </g>
              <g id="Group-6" transform="translate(12.000000, 4.000000)">
                <g id="Fill-4-Clipped">
                  <g>
                    <mask id="mask-4" fill="white">
                      <use xlinkHref="#path-3"></use>
                    </mask>
                    <g id="path-3"></g>
                    <path
                      d="M10.8979456,4.21631645 L13.6502322,4.21631645 L13.6502322,0.148640094 L10.2323023,0.148640094 L9.52561813,0.148640094 C9.52561813,0.148640094 6.93257719,0.088591342 5.2794076,2.10868442 C5.2794076,2.10868442 4.15332573,3.1068518 4.13619708,6.02944127 L4.13551871,6.02944127 L4.13551871,9.07991097 L0.0588988304,9.07991097 L0.0588988304,13.3986592 L4.13551871,13.3986592 L4.13551871,24.5556512 L8.8374193,24.5556512 L8.8374193,13.3986592 L12.8821561,13.3986592 L13.4458754,9.07991097 L8.8374193,9.07991097 L8.8374193,6.02944127 L8.83606257,6.02944127 C8.84742515,5.68869307 9.00887544,4.18570173 10.8979456,4.21631645"
                      id="Fill-4"
                      fill="#FFFFFF"
                      fillRule="nonzero"
                      mask="url(#mask-4)"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FacebookDarkIcon;
